import React, { useEffect, useState } from "react";
import { Download } from "lucide-react";
import { api, API, formatApiErrorDetail } from "@/lib/api";
import { TxTable } from "@/components/TxTable";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { PdfViewer } from "@/components/PdfViewer";

const origin = API.replace(/\/api$/, "");

export const WalletMovements = ({ version }) => {
  const [items, setItems] = useState(null);
  const [error, setError] = useState("");
  const [preview, setPreview] = useState(null);
  useEffect(() => {
    api.get("/invoices/transactions").then(({ data }) => setItems(data.items)).catch((e) => setError(formatApiErrorDetail(e.response?.data?.detail) || "Movimenti non disponibili"));
  }, [version]);
  return <Card className="glow-border" data-testid="wallet-movements">
    {error && <p role="alert" className="p-4 text-sm text-destructive" data-testid="wallet-movements-error">{error}</p>}
    {items === null && !error && <p className="p-4 text-sm text-muted-foreground">Caricamento…</p>}
    {items?.length === 0 && <p className="p-6 text-center text-sm text-muted-foreground" data-testid="wallet-movements-empty">Nessun movimento.</p>}
    <div data-testid="wallet-movements-list">{items?.length > 0 && <TxTable items={items} prefix="wallet-txn" onPreview={setPreview} />}</div>
    <Dialog open={!!preview} onOpenChange={(o) => !o && setPreview(null)}>
      <DialogContent className="w-[calc(100vw-1.5rem)] sm:max-w-3xl" onOpenAutoFocus={(e) => e.preventDefault()} data-testid="wallet-receipt-dialog">
        <DialogHeader><DialogTitle>Ricevuta di ricarica</DialogTitle></DialogHeader>
        {preview && <><PdfViewer src={`${origin}${preview.receipt_url}`} className="h-[65dvh]" testid="wallet-receipt-frame" />
          <div className="flex flex-wrap gap-2"><Button asChild><a href={`${origin}${preview.receipt_url}`} download data-testid="wallet-receipt-dialog-download"><Download className="w-4 h-4" />Scarica PDF</a></Button><Button asChild variant="outline"><a href={`${origin}${preview.receipt_url}`} target="_blank" rel="noreferrer" data-testid="wallet-receipt-open-tab">Apri in una nuova scheda</a></Button></div></>}
      </DialogContent>
    </Dialog>
  </Card>;
};
